import React from 'react';

import { AiMbl } from '../../../../fms.core/AiMbl';

import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import TextBox from '../../../../ui/TextBox';
import Date from '../../../../ui/Date';
import DateTime from '../../../../ui/DateTime';

import InlineInputControlRowNoLabel from '../../../../ui/layout/InlineInputControlRowNoLabel';
import BlueTitleRow from '../../../../ui/BlueTitleRow';
import BlStatusRow from '../../../common/BlStatusRow';
import MawbAirLineStatus from './MawbAirLineStatus';
import { PimsCntrEvent } from '../../../../fms.core/PimsCntrEvent';
import useTableStorage from '../../../../hooks/useTableStorage';

function MawbMilestone({
  mawb,
  onChange,
}: {
  mawb: AiMbl,
  onChange: (x: Partial<AiMbl>) => void,
}) {
  const tableStorage = useTableStorage();

  function onContainerStatusChange(status: Array<PimsCntrEvent>) {

    let result: Partial<AiMbl> = {};

    status.forEach(s => {
      switch (s.seq) {
        case 0:
          result = {
            pickupDate: s.datetime,
            pickupLoc: s.locName ?? '',
          };
          break;
        case 1:
          result = {
            atd: s.datetime,
            atdLoc: s.locName ?? '',
          };
          break;
        case 2:
          result = {
            customsRls: s.datetime,
            customsRlsLoc: s.locName ?? '',
            isCustomsRls: s.check
          };
          break;
        case 3:
          result = {
            ata: s.datetime,
            ataLoc: s.locName ?? '',
          };
          break;
        case 4:
          result = {
            avail: s.datetime,
            availLoc: s.locName ?? '',
          };
          break;
        case 5:
          result = {
            delivery: s.datetime,
            delvLoc: s.locName ?? '',
          };
          break;
      }
    });

    onChange({ ...result });
  }

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <div style={{ marginLeft: '30px', width: '295px' }}>
          <InlineInputControlRow label="MAWB #" bold mode="w115">
            <div style={{ width: '100px' }}>
              <TextBox value={mawb.mawbNo} disabled />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="Departure Airport" mode="w115">
            <TextBox value={mawb.departureName} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="First port of Entry" mode="w115">
            <TextBox value={mawb.firstPort} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Destination Airport" mode="w115">
            <TextBox value={mawb.discharge} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Carrier" mode="w115">
            <TextBox value={mawb.carrierName} disabled />
          </InlineInputControlRow>

          <InlineInputControlRow label="Freight Location" mode="w115">
            <TextBox value={mawb.fLocationName} disabled />
          </InlineInputControlRow>
        </div>

        <div style={{ marginLeft: '30px', width: '325px' }}>
          <InlineInputControlRowNoLabel>
            &nbsp;
          </InlineInputControlRowNoLabel>

          <InlineInputControlRow label="ETD" mode="w60">
            <div style={{ width: '130px' }}>
              <DateTime disabled value={mawb.etd} />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="ETA" mode="w60">
            <div style={{ width: '130px' }}>
              <DateTime disabled value={mawb.firstPortETA} />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="ETA *" mode="w60">
            <div style={{ width: '130px' }}>
              <DateTime disabled value={mawb.eta} />
            </div>
          </InlineInputControlRow>
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ width: '325px' }}>
          <div style={{ marginLeft: '30px' }}>
            <InlineInputControlRow label="Storage Start Date" mode="w115">
              <div style={{ width: '80px' }}>
                <Date disabled value={mawb.storageDate} />
              </div>
            </InlineInputControlRow>

            <InlineInputControlRow label="G.O Date" mode="w115">
              <div style={{ width: '80px' }}>
                <Date disabled value={mawb.goDate} />
              </div>
            </InlineInputControlRow>
          </div>
        </div>

        <div style={{ marginLeft: '30px', width: '325px' }}>
          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="OP Close"
              disabled
              checked={!!mawb.closeDate}
              onToggle={checked => {
                //window.console.log(checked);
              }}
              dateTime={mawb.closeDate}
              userId={mawb.closedBy}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>

          <InlineInputControlRowNoLabel smallMargin>
            <BlStatusRow
              label="Period Close"
              disabled
              checked={mawb.actClosed}
              onToggle={() => { }}
              dateTime={mawb.actClosed ? mawb.actCloseDate : ''}
              userId={mawb.actClosed ? mawb.actClosedBy : ''}
              showDatePlaceHolder={false}
            />
          </InlineInputControlRowNoLabel>
        </div>
      </div>

      <div style={{ marginTop: '10px' }}>
        <BlueTitleRow title={<span style={{ paddingLeft: '14px' }}>Airline Status</span>} />
      </div>

      <MawbAirLineStatus
        status={mawb.milestone?.eventItemList ?? null}
        onChange={onContainerStatusChange}
        tableStorage={tableStorage}
        mawb={mawb}
      />
    </div>
  );
}

export default React.memo(MawbMilestone);
